// Subordinates

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { SUBORDINATES_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "lucide-react";
import { cn } from "../../utils/tailwindUtils";

const SubordinatesReport = () => {

    const [subordinatesData, setSubordinatesData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    let navigate = useNavigate()
    const SubordinatesColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "department",
            Header: "Department",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "date_of_joining",
            Header: "Date Of Joining",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "employee_group",
            Header: "Employee Group",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "email_id",
            Header: "Email Id",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "is_active",
            Header: "Status",
            Cell: ({ value }) => (
                <span
                    className={cn(
                        "px-2 py-1 text-xs font-medium rounded-full",
                        value
                            ? "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300"
                            : "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300"
                    )}
                >
                    {value ? "Active" : "Inactive"}
                </span>
            ),
        }
    ];

    return (
        <div className="p-4 dark:bg-gray-900 rounded-lg dark:shadow-md font-sans">
            <div className="flex justify-between items-center mb-4">
                <span className=" flex gap-2 items-center">
                    <ChevronLeftIcon onClick={() => { navigate('/reports') }} className=" cursor-pointer" />
                    <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                        Subordinate Report ({totalRecords})
                    </h1>
                </span>
            </div>

            <Reactable
                columns={SubordinatesColumns}
                data={subordinatesData}
                setData={setSubordinatesData}
                setTotalCount={setTotalRecords}
                url={SUBORDINATES_REPORTS}
                serverSide={true}
                tableHeight="calc(100vh - 310px)"
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
            />
        </div >
    );
}

export default SubordinatesReport;